// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#openbay section.add-owned-vehicle[data-v-7c2cbc7e]{max-height:100%}#openbay section.add-owned-vehicle[data-v-7c2cbc7e] .search-results{max-height:50vh;overflow-y:auto;position:absolute;width:100%;z-index:9999}@media(min-width:768px){#openbay section.add-owned-vehicle[data-v-7c2cbc7e] .search-results{border-bottom:1px solid #e5e8ed}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
